/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IBreadcrumbViewProps } from '@msdyn365-commerce-modules/breadcrumb';
import { IBreadcrumbProps } from '../definition-extensions/breadcrumb.ext.props.autogenerated';

const BreadCrumbView: React.FC<IBreadcrumbViewProps & IBreadcrumbProps<{}>> = props => {
    const { root, links, backButton, BreadcrumbContainer, BreadcrumbList, BreadcrumbListItem, separator } = props;
    if (!root && !links && !backButton) {
        props.context.telemetry.error('BreadCrumb content is empty, module wont render');
        return null;
    }

    let localizedRoot: React.ReactNode | React.ReactElement;

    // @ts-ignore
    if (root?.props?.text === 'Back to Order History') {
        // @ts-ignore
        localizedRoot = React.cloneElement(root, {
            text: props.resources.backToOrderHistory,
            ariaLabel: props.resources.backToOrderHistory
        });
    } else {
        localizedRoot = root;
    }

    const breadcrumbItems = React.useMemo(() => links?.slice(0, -1), [links]);

    // TODO add isMobile check
    // if ((breadcrumbItems?.length || 0) <= 1) return null;

    return (
        <Module {...BreadcrumbContainer}>
            <Node {...BreadcrumbList}>
                {localizedRoot && (
                    <Node {...BreadcrumbListItem}>
                        {localizedRoot}
                        {links && separator}
                    </Node>
                )}
                {backButton && <Node {...BreadcrumbListItem}>{backButton}</Node>}
                {breadcrumbItems?.length &&
                    breadcrumbItems.map((link, index) => (
                        <React.Fragment key={index}>
                            <Node
                                {...BreadcrumbListItem}
                                className={classnames(
                                    BreadcrumbListItem.className,
                                    index === breadcrumbItems.length - 2 ? 'breadcrumb_item-current' : ''
                                )}
                            >
                                {link}
                                {breadcrumbItems[index + 1] && separator}
                            </Node>
                        </React.Fragment>
                    ))}
            </Node>
        </Module>
    );
};

export default BreadCrumbView;
